import { createSlice } from "@reduxjs/toolkit";

// `value: null` — aucune langue choisie pour l'instant. C'est ce qui permet à
// App.js de distinguer « jamais réglé » de « l'utilisateur a choisi le
// français » et de ne détecter la langue du système qu'une seule fois, au
// tout premier lancement (bug corrigé le 14/09/2026 : l'ancien reducer
// écrivait l'action entière dans `state.value` au lieu de `action.payload`,
// et rien ne l'appelait jamais — la langue n'avait donc jamais changé).
export const langStore = createSlice({
  name: "lang",
  initialState: {
    value: null,
  },
  reducers: {
    changeLang: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { changeLang } = langStore.actions;

export default langStore.reducer;
